module.exports = __webpack_public_path__ + "static/media/descrip3.69b280a5.png";